<template>
  <div v-show="coordinates.length">
    <div class="border">
      <div class="progress">
        <v-progress-circular v-show="showProgress" :size="16" indeterminate></v-progress-circular>
      </div>
      <div :class="showProgress ? 'un_active' : 'active'">
        <label>Y ({{ $t('MEASUREMENT_SYSTEM') }})</label> <span>{{ metres[0] }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <label>X ({{ $t('MEASUREMENT_SYSTEM') }})</label> <span>{{ metres[1] }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <label>Z ({{ $t('MEASUREMENT_SYSTEM') }})</label> <span>{{ metres[2] }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { useUnitDisplay } from "@/composables/useUnitDisplay";

export default {
	name: "CoordinatePanel",
	setup() {
		const { toDisplayDistance } = useUnitDisplay();
		return {
			toDisplayDistance,
		};
	},
	data() {
		return {
			metres: [],
		};
	},
	props: {
		coordinates: Array,
		showProgress: Boolean,
	},
	watch: {
		coordinates(newValue) {
			this.metres = [
				this.toDisplayDistance(newValue[0] ?? 0, 3).formatted,
				this.toDisplayDistance(newValue[1] ?? 0, 3).formatted,
				this.toDisplayDistance(newValue[2] ?? 0, 3).formatted,
			];
		},
	},
};
</script>
<style scoped>
.border {
  position: absolute;
  padding: 4px;
  display: flex;
  z-index: 1;
  right: 53px;
  bottom: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-items: center;
}

.progress {
  opacity: 0.8;
  margin-left: 4px;
  margin-right: 4px;
  width: 20px;
}

.active,
.un_active label {
  opacity: 0.8;
}

.un_active span {
  opacity: 0.5;
}
</style>